import constant from "../../constant";
import axios from "axios";
import router from "../../router";
const api = constant.api + "services";
// initial state
const state = () => ({
  all: [],
  services: [],
  service: {},
});

// getters
const getters = {
  getAll: (state) => {
    return state.all;
  },
  getService: (state) => {
    return state.service;
  },

  getServices: (state) => {
    return state.services;
  },
};

// actions
const actions = {
  async getAll({ commit }) {
    // Use shared $api helper like items module
    const services = await this.$api.fetch(api);
    commit("setServices", services);
  },

  async getServicesPrices({ commit }) {
    const services = await this.$api.fetch(api + "_prices");
    commit("setServicesPrices", services);
  },

  async show({ commit }, reference) {
    const response = await this.$api.show(api + "/" + reference);
    const service = response.data || response;
    commit("setService", service);
  },

  async store({ dispatch }, data) {
    await this.$api.create(api, data);
  },

  async storeAndRouteToPurchase({ dispatch }, data) {
    const response = await this.$api.create(api, data);
    if (!response) return;
    const serviceData = response.data.data || response.data;
    router.push({
      name: "purchases-services-create",
      query: { service_reference: serviceData.reference },
    });
  },

  async storePrice({ commit, dispatch }, data) {
    const response = await this.$api.create(api + "_prices", data, {
      confirm: false,
    });
    if (response && response.data && response.data.status == "success") {
      commit("setServicesPrices", response.data.data);
    }
  },

  async update({ dispatch }, data) {
    // For file uploads, use axios instance directly with multipart/form-data
    const response = await axios.post(api + "/" + data.get("reference"), data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      timeout: 30000,
    });

    if (response.data && response.data.status == "success") {
      router.push({
        name: "services-index",
      });
    }
  },

  async destroy({ commit, dispatch }, reference) {
    const response = await this.$api.delete(api + "/" + reference);
    if (response && response.data && response.data.status == "success") {
      const services = response.data.data;
      commit("setServices", services);
    }
  },

  async printAll({ dispatch }) {
    // For PDF blob downloads, use axios directly (like items module)
    const response = await axios.get(api + "_print", {
      responseType: "blob",
      timeout: 30000,
    });

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "Catalogue.pdf");
    link.click();
    window.URL.revokeObjectURL(url);
  },
};

// mutations
const mutations = {
  setServices(state, services) {
    state.all = services;
    state.services = services;
  },
  setServicesPrices(state, services) {
    state.all = services;
    state.services = services;
  },
  setService(state, service) {
    state.service = service;
  },
  async search(state, value) {
    value = value.charAt(0).toUpperCase() + value.slice(1);
    console.log(value);
    state.services = state.all.filter(function (service) {
      return (
        service.firstName.toUpperCase().indexOf(value.toUpperCase()) > -1 ||
        service.lastName.toUpperCase().indexOf(value.toUpperCase()) > -1 ||
        service.phone.toUpperCase().indexOf(value.toUpperCase()) > -1 ||
        service.reference.toUpperCase().indexOf(value.toUpperCase()) > -1
      );
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
